import { render, staticRenderFns } from "./UserDashboardTabElement.vue?vue&type=template&id=735696da&scoped=true"
import script from "./UserDashboardTabElement.vue?vue&type=script&lang=js"
export * from "./UserDashboardTabElement.vue?vue&type=script&lang=js"
import style0 from "./UserDashboardTabElement.vue?vue&type=style&index=0&id=735696da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735696da",
  null
  
)

export default component.exports